"use strict";
/* eslint-disable import/extensions */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var api_1 = require("@src/api");
var BotActions_1 = require("@src/actions/BotActions");
var dispatcher_1 = require("@src/dispatcher");
var CommonStore_1 = __importDefault(require("@src/stores/CommonStore"));
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
var DomainActions_1 = require("@src/actions/DomainActions");
var const_1 = require("@src/containers/CodeNode/utils/const");
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var accordion_1 = __importDefault(require("relements/build/esm/ui/accordion"));
var dropdown_1 = __importDefault(require("relements/build/esm/input/dropdown"));
var loader_1 = __importDefault(require("relements/build/esm/ui/loader"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var toggle_1 = __importDefault(require("relements/build/esm/input/toggle"));
// Store
var store_1 = __importDefault(require("@src/store"));
// Components
// eslint-disable-next-line import/extensions
var StyledComponets_1 = require("./StyledComponets");
// eslint-disable-next-line import/extensions
var Label_1 = __importDefault(require("./Label"));
var VoiceAgentToolItem_1 = __importDefault(require("./VoiceAgentToolItem"));
var VoiceAgentSidebar_1 = __importDefault(require("./VoiceAgentSidebar"));
var VoiceAgentAddAgentModal_1 = __importDefault(require("./VoiceAgentAddAgentModal"));
var VoiceAgentDynamicSettings_1 = __importDefault(require("./VoiceAgentDynamicSettings"));
var VoiceAgentLayoutUtils_1 = require("./VoiceAgentLayoutUtils");
var api_2 = require("../store/api");
var selectors_1 = require("../store/selectors");
var actions_1 = require("../store/actions");
var normalizeDynamicSettingsTemplate = function (template) {
    if (Array.isArray(template))
        return template;
    if (Array.isArray(template === null || template === void 0 ? void 0 : template.agent_settings_template)) {
        return template.agent_settings_template;
    }
    if (Array.isArray(template === null || template === void 0 ? void 0 : template.dynamic_settings)) {
        return template.dynamic_settings;
    }
    if (Array.isArray(template === null || template === void 0 ? void 0 : template.settings)) {
        return template.settings;
    }
    return [];
};
var VoiceAgentLayout = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
    var onAddAgentClick = _a.onAddAgentClick, onDeleteClick = _a.onDeleteClick, onParentSave = _a.onSave, isEdited = _a.isEdited, onDirtyStateChange = _a.onDirtyStateChange;
    var reduxDispatch = react_redux_1.useDispatch();
    var languages = CommonStore_1["default"].getMetaTags().allLanguages;
    var activeDomainId = (_c = (_b = CommonStore_1["default"].getMetaTags()) === null || _b === void 0 ? void 0 : _b.domain) === null || _c === void 0 ? void 0 : _c.id;
    var botSettings = react_redux_1.useSelector(selectors_1.getDomainData);
    var botSettingsDomainId = (_d = botSettings === null || botSettings === void 0 ? void 0 : botSettings.id) !== null && _d !== void 0 ? _d : botSettings === null || botSettings === void 0 ? void 0 : botSettings.domain_id;
    var isDomainDataSynced = String(botSettingsDomainId !== null && botSettingsDomainId !== void 0 ? botSettingsDomainId : '') === String(activeDomainId !== null && activeDomainId !== void 0 ? activeDomainId : '');
    var pipecatVoiceId = isDomainDataSynced
        ? Number(botSettings === null || botSettings === void 0 ? void 0 : botSettings['pipecat_voice_id'])
        : Number.NaN;
    var languagesList = languages.filter(function (lang) { var _a; return (_a = botSettings === null || botSettings === void 0 ? void 0 : botSettings['supported_languages']) === null || _a === void 0 ? void 0 : _a.includes(lang.code); });
    var _x = react_1["default"].useState([]), agents = _x[0], setAgents = _x[1];
    var _y = react_1["default"].useState([]), agentSettingsTemplate = _y[0], setAgentSettingsTemplate = _y[1];
    var _z = react_1["default"].useState(null), selectedSelection = _z[0], setSelectedSelection = _z[1];
    var _0 = react_1["default"].useState(languagesList[0]), selectedLanguage = _0[0], setSelectedLanguage = _0[1];
    var initializedLanguageKeyRef = react_1["default"].useRef('');
    var _1 = react_1["default"].useState(null), currentAgentDraft = _1[0], setCurrentAgentDraft = _1[1];
    var _2 = react_1["default"].useState(VoiceAgentLayoutUtils_1.normalizeCommonConfigurationDraft(botSettings)), currentCommonDraft = _2[0], setCurrentCommonDraft = _2[1];
    var _3 = react_1["default"].useState((_f = (_e = VoiceAgentLayoutUtils_1.normalizeCommonConfigurationDraft(botSettings)) === null || _e === void 0 ? void 0 : _e.tools) !== null && _f !== void 0 ? _f : []), commonTools = _3[0], setCommonTools = _3[1];
    var _4 = react_1["default"].useState(false), isLocalEdited = _4[0], setIsLocalEdited = _4[1];
    var _5 = react_1["default"].useState(false), isCommonEdited = _5[0], setIsCommonEdited = _5[1];
    var _6 = react_1["default"].useState([]), voiceModels = _6[0], setVoiceModels = _6[1];
    var _7 = react_1["default"].useState(true), isLoading = _7[0], setIsLoading = _7[1];
    var _8 = react_1["default"].useState(true), isModelsLoading = _8[0], setIsModelsLoading = _8[1];
    var _9 = react_1["default"].useState(false), isSaving = _9[0], setIsSaving = _9[1];
    var _10 = react_1["default"].useState(false), isDeleteLoading = _10[0], setIsDeleteLoading = _10[1];
    var _11 = react_1["default"].useState(false), isAddAgentModalActive = _11[0], setIsAddAgentModalActive = _11[1];
    var _12 = react_1["default"].useState(false), dynamicSettingsAccordionActive = _12[0], setDynamicSettingsAccordionActive = _12[1];
    var _13 = react_1["default"].useState(''), newAgentName = _13[0], setNewAgentName = _13[1];
    var _14 = react_1["default"].useState(''), newAgentNameError = _14[0], setNewAgentNameError = _14[1];
    var lastAccordionResetAgentIdRef = react_1["default"].useRef(null);
    var ensureToolCallLambdaNames = react_1["default"].useCallback(function (draft) { return __awaiter(void 0, void 0, void 0, function () {
        var tools, pendingLambdaTools, updatedTools, lambdaResults;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    tools = Array.isArray(draft === null || draft === void 0 ? void 0 : draft.tools) ? draft.tools : [];
                    pendingLambdaTools = tools
                        .map(function (tool, index) { return ({ tool: tool, index: index }); })
                        .filter(function (_a) {
                        var tool = _a.tool;
                        return ((tool === null || tool === void 0 ? void 0 : tool.mode) || '').toString().trim() === 'tool_call' &&
                            Boolean(tool === null || tool === void 0 ? void 0 : tool.isNew) &&
                            !((tool === null || tool === void 0 ? void 0 : tool.lambdaFunctionName) || '').toString().trim();
                    });
                    if (!pendingLambdaTools.length) {
                        return [2 /*return*/, draft];
                    }
                    updatedTools = __spreadArrays(tools);
                    return [4 /*yield*/, Promise.all(pendingLambdaTools.map(function (_a) {
                            var tool = _a.tool, index = _a.index;
                            return __awaiter(void 0, void 0, void 0, function () {
                                var payload, response, responseBody, lambdaFunctionName;
                                var _b, _c, _d;
                                return __generator(this, function (_e) {
                                    switch (_e.label) {
                                        case 0:
                                            payload = {};
                                            // The API expects snake_case payload keys here.
                                            // eslint-disable-next-line camelcase, dot-notation
                                            payload['custom_code_block'] =
                                                (tool === null || tool === void 0 ? void 0 : tool.code) || (tool === null || tool === void 0 ? void 0 : tool['custom_code_block']) || const_1.INIT_CODE_MULTI_VOICE_AGENT;
                                            if (((tool === null || tool === void 0 ? void 0 : tool.lambdaFunctionName) || '').toString().trim()) {
                                                // eslint-disable-next-line camelcase, dot-notation
                                                payload['lambda_function_name'] = tool.lambdaFunctionName;
                                            }
                                            return [4 /*yield*/, api_2.createCodeExecutorFunction(payload)];
                                        case 1:
                                            response = _e.sent();
                                            if (!(response === null || response === void 0 ? void 0 : response.success)) {
                                                throw new Error(((_b = response === null || response === void 0 ? void 0 : response.response) === null || _b === void 0 ? void 0 : _b.error) ||
                                                    "Failed to generate lambda name for Tool " + (index + 1) + ".");
                                            }
                                            responseBody = VoiceAgentLayoutUtils_1.getResponseBody(response === null || response === void 0 ? void 0 : response.response);
                                            lambdaFunctionName = (_d = (_c = responseBody === null || responseBody === void 0 ? void 0 : responseBody['lambda_function_name']) !== null && _c !== void 0 ? _c : responseBody === null || responseBody === void 0 ? void 0 : responseBody['function_name']) !== null && _d !== void 0 ? _d : '';
                                            if (!lambdaFunctionName) {
                                                throw new Error("Lambda name was not returned for Tool " + (index + 1) + ".");
                                            }
                                            return [2 /*return*/, { index: index, lambdaFunctionName: lambdaFunctionName }];
                                    }
                                });
                            });
                        }))];
                case 1:
                    lambdaResults = _a.sent();
                    lambdaResults.forEach(function (_a) {
                        var index = _a.index, lambdaFunctionName = _a.lambdaFunctionName;
                        updatedTools[index] = __assign(__assign({}, (updatedTools[index] || {})), { lambdaFunctionName: lambdaFunctionName });
                    });
                    return [2 /*return*/, __assign(__assign({}, (draft || {})), { tools: updatedTools })];
            }
        });
    }); }, []);
    var selectedAgentId = selectedSelection === VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION
        ? null
        : selectedSelection;
    var selectedAgent = react_1["default"].useMemo(function () {
        if (!agents.length)
            return null;
        return (agents.find(function (agent) { return VoiceAgentLayoutUtils_1.getAgentId(agent) === selectedAgentId; }) || agents[0]);
    }, [agents, selectedAgentId]);
    var selectedLanguageCode = (selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.code) || (selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.id);
    var getDefaultLanguage = function () {
        var languageSpecificInstructions = (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.languageSpecificInstructions) || {};
        var languageWithValue = languagesList.find(function (lang) {
            var languageCode = (lang === null || lang === void 0 ? void 0 : lang.code) || (lang === null || lang === void 0 ? void 0 : lang.id);
            return (languageCode &&
                ((languageSpecificInstructions === null || languageSpecificInstructions === void 0 ? void 0 : languageSpecificInstructions[languageCode]) || '').toString().trim()
                    .length > 0);
        });
        return languageWithValue || languagesList[0] || null;
    };
    var configuredLanguageCount = Object.values((currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.languageSpecificInstructions) || {}).filter(function (value) { return (value || '').toString().trim().length > 0; }).length;
    var isAgentDefault = function (agent) { var _a, _b; return Boolean((_b = (_a = agent === null || agent === void 0 ? void 0 : agent['is_default']) !== null && _a !== void 0 ? _a : agent === null || agent === void 0 ? void 0 : agent.isDefault) !== null && _b !== void 0 ? _b : false); };
    var defaultAgentOtherThanCurrent = agents.find(function (agent) { return isAgentDefault(agent) && VoiceAgentLayoutUtils_1.getAgentId(agent) !== selectedAgentId; });
    var noDefaultAgent = !(agents === null || agents === void 0 ? void 0 : agents.some(function (agent) { return isAgentDefault(agent); }));
    var orchestratorAgentOtherThanCurrent = agents.find(function (agent) {
        return ((agent === null || agent === void 0 ? void 0 : agent.role) === 'orchestrator' || (agent === null || agent === void 0 ? void 0 : agent['role']) === 'orchestrator') &&
            VoiceAgentLayoutUtils_1.getAgentId(agent) !== selectedAgentId;
    });
    var isFaq = (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.role) === 'faq';
    var selectedAgentSettingsTemplate = normalizeDynamicSettingsTemplate((_h = (_g = selectedAgent === null || selectedAgent === void 0 ? void 0 : selectedAgent.agent_settings_template) !== null && _g !== void 0 ? _g : selectedAgent === null || selectedAgent === void 0 ? void 0 : selectedAgent.agentSettingsTemplate) !== null && _h !== void 0 ? _h : agentSettingsTemplate);
    var commonConfigurationSource = react_1["default"].useMemo(function () { return (__assign(__assign({}, (botSettings || {})), { common_tools: commonTools })); }, [botSettings, commonTools]);
    var currentCommonConfiguration = react_1["default"].useMemo(function () { return VoiceAgentLayoutUtils_1.normalizeCommonConfigurationDraft(commonConfigurationSource); }, [commonConfigurationSource]);
    var sharedCommonTools = commonTools;
    var allAgentTools = react_1["default"].useMemo(function () {
        return agents.flatMap(function (agent) {
            return Array.isArray(agent === null || agent === void 0 ? void 0 : agent.tools) ? agent.tools : [];
        });
    }, [agents]);
    var selectedAgentDisplayName = ((currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.name) || (selectedAgent === null || selectedAgent === void 0 ? void 0 : selectedAgent.name) ||
        '')
        .toString()
        .trim();
    var normalizedSelectedAgentDisplayName = selectedAgentDisplayName
        .toLowerCase()
        .trim();
    var normalizedSelectedAgentId = String(selectedAgentId !== null && selectedAgentId !== void 0 ? selectedAgentId : '').trim();
    var isCommonToolSelfHandoff = function (tool) {
        if (((tool === null || tool === void 0 ? void 0 : tool.mode) || '').toString().trim() !== 'handoff')
            return false;
        var nextAgentValue = ((tool === null || tool === void 0 ? void 0 : tool.nextAgent) || '').toString().trim();
        if (!nextAgentValue)
            return false;
        var normalizedNextAgent = nextAgentValue.toLowerCase();
        return (normalizedNextAgent === normalizedSelectedAgentDisplayName ||
            nextAgentValue === normalizedSelectedAgentId);
    };
    var providerOptions = (function () {
        var providers = new Set();
        voiceModels.forEach(function (model) {
            var _a;
            var provider = (_a = model === null || model === void 0 ? void 0 : model['meta_data']) === null || _a === void 0 ? void 0 : _a.provider;
            if (provider)
                providers.add(provider);
        });
        return Array.from(providers).map(function (provider) { return ({
            id: provider,
            name: provider,
        }); });
    })();
    var modelOptions = (function () {
        return voiceModels
            .filter(function (model) {
            var _a;
            if (!(currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.modelProvider))
                return true;
            var provider = (_a = model === null || model === void 0 ? void 0 : model['meta_data']) === null || _a === void 0 ? void 0 : _a.provider;
            return provider === currentAgentDraft.modelProvider;
        })
            .map(function (model) {
            var _a, _b;
            return ({
                // id: model?.id ?? model?.name,
                id: (_a = model === null || model === void 0 ? void 0 : model.name) !== null && _a !== void 0 ? _a : model === null || model === void 0 ? void 0 : model.id,
                name: (_b = model === null || model === void 0 ? void 0 : model.name) !== null && _b !== void 0 ? _b : model === null || model === void 0 ? void 0 : model.id,
            });
        })
            .filter(function (model) { return model.id; });
    })();
    var agentOptions = react_1["default"].useMemo(function () {
        return agents.map(function (agent, index) { return ({
            id: VoiceAgentLayoutUtils_1.getAgentId(agent),
            name: VoiceAgentLayoutUtils_1.getAgentName(agent, index),
        }); });
    }, [agents]);
    var fetchVoiceModels = react_1["default"].useCallback(function () {
        setIsModelsLoading(true);
        api_2.getVoiceModels()
            .then(function (_a) {
            var success = _a.success, response = _a.response;
            if (!success)
                return;
            var body = VoiceAgentLayoutUtils_1.getResponseBody(response);
            setVoiceModels(VoiceAgentLayoutUtils_1.normalizeList(body));
        })["catch"](function (error) {
            api_1.captureException(error);
        })["finally"](function () {
            setIsModelsLoading(false);
        });
    }, []);
    var fetchMultiAgents = react_1["default"].useCallback(function (preferredAgentId) {
        if (preferredAgentId === void 0) { preferredAgentId = null; }
        if (!Number.isFinite(pipecatVoiceId))
            return;
        setIsLoading(true);
        api_2.getMultiAgent(pipecatVoiceId)
            .then(function (_a) {
            var _b, _c, _d, _e, _f, _g, _h, _j, _k;
            var success = _a.success, response = _a.response;
            if (!success) {
                BotActions_1.createAlert((response === null || response === void 0 ? void 0 : response.error) || 'Failed to fetch voice agents.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                setAgents([]);
                setCurrentAgentDraft(null);
                setSelectedSelection(null);
                setCommonTools([]);
                return;
            }
            var body = VoiceAgentLayoutUtils_1.getResponseBody(response);
            var fetchedAgents = VoiceAgentLayoutUtils_1.normalizeList((_c = (_b = body === null || body === void 0 ? void 0 : body.agents) !== null && _b !== void 0 ? _b : body === null || body === void 0 ? void 0 : body.data) !== null && _c !== void 0 ? _c : []);
            var fetchedTemplate = normalizeDynamicSettingsTemplate((_f = (_e = (_d = body === null || body === void 0 ? void 0 : body.agent_settings_template) !== null && _d !== void 0 ? _d : body === null || body === void 0 ? void 0 : body.agentSettingsTemplate) !== null && _e !== void 0 ? _e : body === null || body === void 0 ? void 0 : body.dynamic_settings) !== null && _f !== void 0 ? _f : body === null || body === void 0 ? void 0 : body.settings);
            setAgents(fetchedAgents !== null && fetchedAgents !== void 0 ? fetchedAgents : []);
            setAgentSettingsTemplate(fetchedTemplate !== null && fetchedTemplate !== void 0 ? fetchedTemplate : []);
            setCommonTools((_j = (_h = VoiceAgentLayoutUtils_1.normalizeCommonConfigurationDraft({
                common_tools: (_g = body === null || body === void 0 ? void 0 : body.common_tools) !== null && _g !== void 0 ? _g : [],
            })) === null || _h === void 0 ? void 0 : _h.tools) !== null && _j !== void 0 ? _j : []);
            if (!fetchedAgents.length) {
                setSelectedSelection(preferredAgentId === VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION
                    ? VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION
                    : null);
                setCurrentAgentDraft(null);
                return;
            }
            var idToSelect = preferredAgentId === VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION
                ? VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION
                : (_k = preferredAgentId !== null && preferredAgentId !== void 0 ? preferredAgentId : VoiceAgentLayoutUtils_1.getAgentId(fetchedAgents[0])) !== null && _k !== void 0 ? _k : null;
            setSelectedSelection(idToSelect);
        })["catch"](function (error) {
            BotActions_1.createAlert('Error occurred while fetching voice agents.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            api_1.captureException(error);
        })["finally"](function () {
            setIsLoading(false);
        });
    }, [pipecatVoiceId]);
    react_1["default"].useEffect(function () {
        if (selectedSelection === VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION) {
            setCurrentCommonDraft(currentCommonConfiguration);
            setIsCommonEdited(false);
            setCurrentAgentDraft(null);
            return;
        }
        if (!selectedAgent) {
            setCurrentAgentDraft(null);
            return;
        }
        var selectedAgentDraft = VoiceAgentLayoutUtils_1.toAgentDraft(selectedAgent);
        setCurrentAgentDraft(selectedAgentDraft);
        setIsLocalEdited(Boolean(selectedAgentDraft === null || selectedAgentDraft === void 0 ? void 0 : selectedAgentDraft.isNew));
        setIsCommonEdited(false);
        if (lastAccordionResetAgentIdRef.current !== selectedAgentId) {
            setDynamicSettingsAccordionActive(false);
            lastAccordionResetAgentIdRef.current = selectedAgentId;
        }
    }, [botSettings, selectedAgent, selectedAgentId, selectedSelection]);
    react_1["default"].useEffect(function () {
        if (selectedSelection !== VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION) {
            setCurrentCommonDraft(currentCommonConfiguration);
            return;
        }
        if (!isCommonEdited) {
            setCurrentCommonDraft(currentCommonConfiguration);
        }
    }, [currentCommonConfiguration, isCommonEdited, selectedSelection]);
    react_1["default"].useEffect(function () {
        setCurrentCommonDraft(currentCommonConfiguration);
        setCommonTools([]);
        setAgents([]);
        setAgentSettingsTemplate([]);
        setSelectedSelection(null);
        setCurrentAgentDraft(null);
        setIsLocalEdited(false);
        setIsCommonEdited(false);
        setIsLoading(true);
        setIsModelsLoading(true);
        setIsAddAgentModalActive(false);
        setNewAgentName('');
        setNewAgentNameError('');
    }, [activeDomainId]);
    react_1["default"].useEffect(function () {
        if (!Number.isFinite(pipecatVoiceId)) {
            setAgents([]);
            setAgentSettingsTemplate([]);
            setSelectedSelection(null);
            setCurrentAgentDraft(null);
            setIsLocalEdited(false);
            setIsCommonEdited(false);
            setIsLoading(false);
            setIsModelsLoading(false);
            return;
        }
        fetchMultiAgents();
        fetchVoiceModels();
    }, [pipecatVoiceId, fetchMultiAgents, fetchVoiceModels]);
    react_1["default"].useEffect(function () {
        var _a, _b;
        if (!languagesList.length) {
            initializedLanguageKeyRef.current = '';
            setSelectedLanguage(null);
            return;
        }
        var draftKey = String((_b = (_a = currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id) !== null && _a !== void 0 ? _a : selectedAgentId) !== null && _b !== void 0 ? _b : 'none');
        var selectedLanguageCode = (selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.code) || (selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.id);
        var selectedExists = selectedLanguageCode
            ? languagesList.some(function (lang) {
                return lang.code === selectedLanguageCode ||
                    lang.id === selectedLanguageCode;
            })
            : false;
        var shouldInitialize = initializedLanguageKeyRef.current !== draftKey || !selectedExists;
        if (shouldInitialize) {
            setSelectedLanguage(getDefaultLanguage());
            initializedLanguageKeyRef.current = draftKey;
        }
    }, [
        currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id,
        currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.languageSpecificInstructions,
        languagesList,
        selectedAgentId,
        selectedLanguage,
    ]);
    react_1["default"].useEffect(function () {
        if (onDirtyStateChange) {
            onDirtyStateChange(Boolean(isLocalEdited || isCommonEdited || isEdited));
        }
        return function () {
            if (onDirtyStateChange)
                onDirtyStateChange(false);
        };
    }, [isCommonEdited, isLocalEdited, isEdited, onDirtyStateChange]);
    var updateAgentDraft = function (field, value) {
        setCurrentAgentDraft(function (prev) {
            var _a;
            var updatedDraft = __assign(__assign({}, (prev || {})), (_a = {}, _a[field] = value, _a));
            if (field === 'role' && value === 'faq') {
                var removedToolIds = (updatedDraft.tools || [])
                    .map(function (tool) { return tool === null || tool === void 0 ? void 0 : tool.id; })
                    .filter(function (toolId) { return toolId !== null && toolId !== undefined; });
                updatedDraft.deletedToolIds = Array.from(new Set(__spreadArrays((updatedDraft.deletedToolIds || []), removedToolIds)));
                updatedDraft.isDefault = false;
                updatedDraft.tools = [];
                updatedDraft.commonToolIds = [];
            }
            return updatedDraft;
        });
        setIsLocalEdited(true);
    };
    var isCommonToolEnabled = function (toolId) {
        if (toolId === null || toolId === undefined)
            return false;
        return ((currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.commonToolIds) || []).some(function (commonToolId) { return String(commonToolId) === String(toolId); });
    };
    var updateCommonToolAccess = function (toolId, enabled) {
        if (toolId === null || toolId === undefined)
            return;
        setCurrentAgentDraft(function (prev) {
            var existingIds = VoiceAgentLayoutUtils_1.normalizeCommonToolIds(prev === null || prev === void 0 ? void 0 : prev.commonToolIds);
            var nextIds = enabled
                ? VoiceAgentLayoutUtils_1.normalizeCommonToolIds(__spreadArrays(existingIds, [toolId]))
                : existingIds.filter(function (commonToolId) { return String(commonToolId) !== String(toolId); });
            return __assign(__assign({}, (prev || {})), { commonToolIds: nextIds });
        });
        setIsLocalEdited(true);
    };
    var updateAgentSettingsDraft = function (key, value) {
        setCurrentAgentDraft(function (prev) {
            var _a;
            return (__assign(__assign({}, (prev || {})), { agentSettings: __assign(__assign({}, ((prev === null || prev === void 0 ? void 0 : prev.agentSettings) || {})), (_a = {}, _a[key] = value, _a)) }));
        });
        setIsLocalEdited(true);
    };
    var updateCommonDraft = function (field, value) {
        setCurrentCommonDraft(function (prev) {
            var _a;
            return (__assign(__assign({}, (prev || currentCommonConfiguration)), (_a = {}, _a[field] = value, _a)));
        });
        setIsCommonEdited(true);
    };
    var updateToolDraft = function (index, field, value) {
        if (selectedSelection === VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION) {
            setCurrentCommonDraft(function (prev) {
                var _a;
                var _b;
                var updatedTools = __spreadArrays(((_b = prev === null || prev === void 0 ? void 0 : prev.tools) !== null && _b !== void 0 ? _b : []));
                updatedTools[index] = __assign(__assign({}, (updatedTools[index] || VoiceAgentLayoutUtils_1.normalizeTool({}))), (_a = {}, _a[field] = value, _a));
                return __assign(__assign({}, (prev || currentCommonConfiguration)), { tools: updatedTools });
            });
            setIsCommonEdited(true);
            return;
        }
        setCurrentAgentDraft(function (prev) {
            var _a;
            var _b;
            var updatedTools = __spreadArrays(((_b = prev === null || prev === void 0 ? void 0 : prev.tools) !== null && _b !== void 0 ? _b : []));
            updatedTools[index] = __assign(__assign({}, (updatedTools[index] || VoiceAgentLayoutUtils_1.normalizeTool({}))), (_a = {}, _a[field] = value, _a));
            return __assign(__assign({}, (prev || {})), { tools: updatedTools });
        });
        setIsLocalEdited(true);
    };
    var onDeleteTool = function (index) {
        if (selectedSelection === VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION) {
            setCurrentCommonDraft(function (prev) {
                var _a;
                var updatedTools = __spreadArrays(((_a = prev === null || prev === void 0 ? void 0 : prev.tools) !== null && _a !== void 0 ? _a : []));
                updatedTools.splice(index, 1);
                return __assign(__assign({}, (prev || currentCommonConfiguration)), { tools: updatedTools });
            });
            setIsCommonEdited(true);
            return;
        }
        setCurrentAgentDraft(function (prev) {
            var _a;
            var updatedTools = __spreadArrays(((_a = prev === null || prev === void 0 ? void 0 : prev.tools) !== null && _a !== void 0 ? _a : []));
            var removedTool = updatedTools[index];
            var removedToolId = removedTool === null || removedTool === void 0 ? void 0 : removedTool.id;
            updatedTools.splice(index, 1);
            return __assign(__assign({}, (prev || {})), { tools: updatedTools, deletedToolIds: removedToolId === null || removedToolId === undefined
                    ? (prev === null || prev === void 0 ? void 0 : prev.deletedToolIds) || []
                    : Array.from(new Set(__spreadArrays(((prev === null || prev === void 0 ? void 0 : prev.deletedToolIds) || []), [removedToolId]))) });
        });
        setIsLocalEdited(true);
    };
    var getAffectedRoutingAgents = function (targetAgentName, deletingAgentId) {
        return agents
            .filter(function (agent) { return VoiceAgentLayoutUtils_1.getAgentId(agent) !== deletingAgentId; })
            .map(function (agent) {
            var draft = VoiceAgentLayoutUtils_1.toAgentDraft(agent);
            var removedTools = ((draft === null || draft === void 0 ? void 0 : draft.tools) || []).filter(function (tool) {
                return (tool === null || tool === void 0 ? void 0 : tool.mode) === 'handoff' && (tool === null || tool === void 0 ? void 0 : tool.nextAgent) === targetAgentName;
            });
            if (!removedTools.length)
                return null;
            return {
                id: draft === null || draft === void 0 ? void 0 : draft.id,
                isNew: Boolean(draft === null || draft === void 0 ? void 0 : draft.isNew),
                name: VoiceAgentLayoutUtils_1.getAgentName(agent, 0),
                removedTools: removedTools,
                updatedDraft: __assign(__assign({}, draft), { tools: ((draft === null || draft === void 0 ? void 0 : draft.tools) || []).filter(function (tool) {
                        return !((tool === null || tool === void 0 ? void 0 : tool.mode) === 'handoff' &&
                            (tool === null || tool === void 0 ? void 0 : tool.nextAgent) === targetAgentName);
                    }), deletedToolIds: Array.from(new Set(__spreadArrays(((draft === null || draft === void 0 ? void 0 : draft.deletedToolIds) || []), removedTools
                        .map(function (tool) { return tool === null || tool === void 0 ? void 0 : tool.id; })
                        .filter(function (toolId) { return toolId !== null && toolId !== undefined; })))) }),
            };
        })
            .filter(Boolean);
    };
    var onAddTool = function () {
        if (selectedSelection === VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION) {
            setCurrentCommonDraft(function (prev) {
                var _a;
                return (__assign(__assign({}, (prev || currentCommonConfiguration)), { tools: __spreadArrays(((_a = prev === null || prev === void 0 ? void 0 : prev.tools) !== null && _a !== void 0 ? _a : []), [VoiceAgentLayoutUtils_1.normalizeTool({ id: null, isNew: true })]) }));
            });
            setIsCommonEdited(true);
            return;
        }
        setCurrentAgentDraft(function (prev) {
            var _a;
            return (__assign(__assign({}, (prev || {})), { tools: __spreadArrays(((_a = prev === null || prev === void 0 ? void 0 : prev.tools) !== null && _a !== void 0 ? _a : []), [VoiceAgentLayoutUtils_1.normalizeTool({ id: null, isNew: true })]) }));
        });
        setIsLocalEdited(true);
    };
    var showToolValidationError = function (validationError) {
        if (!validationError)
            return false;
        if ((validationError === null || validationError === void 0 ? void 0 : validationError.toolIndex) === undefined) {
            BotActions_1.createAlert(validationError.message, null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return true;
        }
        if ((validationError === null || validationError === void 0 ? void 0 : validationError.parameterIndex) !== undefined) {
            var parameterFieldLabel = validationError.field === 'name_format'
                ? 'name can only contain letters, numbers and underscore'
                : validationError.field + " is required";
            BotActions_1.createAlert("Tool " + (validationError.toolIndex + 1) + ", Parameter " + (validationError.parameterIndex + 1) + ": " + parameterFieldLabel + ".", null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return true;
        }
        BotActions_1.createAlert("Tool " + (validationError.toolIndex + 1) + ": " + validationError.message, null, MogamboConstants_1.AlertTypes.NEGATIVE);
        return true;
    };
    var onAddAgent = function () {
        if (isLocalEdited || isCommonEdited || isEdited) {
            BotActions_1.showConfirmationDialog({
                okTitle: 'Continue',
                cancelTitle: 'Keep Editing',
                title: 'Create a new agent?',
                message: 'Your unsaved changes in the current agent will be lost if you continue.',
                okActionType: 'danger',
                onCancel: function () { },
                onOk: function () {
                    setIsAddAgentModalActive(true);
                    setNewAgentName('');
                    setNewAgentNameError('');
                },
            });
            return;
        }
        setIsAddAgentModalActive(true);
        setNewAgentName('');
        setNewAgentNameError('');
    };
    var onConfirmAddAgent = function () {
        var trimmedAgentName = (newAgentName || '').trim();
        if (!trimmedAgentName) {
            setNewAgentNameError('Agent name is required.');
            BotActions_1.createAlert('Please enter an agent name.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        if (trimmedAgentName.length < 5 || trimmedAgentName.length > 50) {
            setNewAgentNameError('Agent name must be between 5 and 50 characters.');
            BotActions_1.createAlert('Agent name must be between 5 and 50 characters.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        if (!VoiceAgentLayoutUtils_1.AGENT_NAME_REGEX.test(trimmedAgentName)) {
            setNewAgentNameError('Agent name can only contain letters, numbers, spaces and underscore.');
            BotActions_1.createAlert('Agent name can only contain letters, numbers, spaces and underscore.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        var isDuplicateAgentName = agents.some(function (agent) {
            return (VoiceAgentLayoutUtils_1.getAgentName(agent, 0) || '').trim().toLowerCase() ===
                trimmedAgentName.toLowerCase();
        });
        if (isDuplicateAgentName) {
            setNewAgentNameError('An agent with this name already exists.');
            BotActions_1.createAlert('Agent name already exists. Please choose a different name.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        setNewAgentNameError('');
        if (!Number.isFinite(pipecatVoiceId) && onAddAgentClick) {
            onAddAgentClick();
        }
        var tempId = "new-" + Date.now();
        var localNewAgent = {
            id: tempId,
            name: trimmedAgentName,
            title: trimmedAgentName,
            llm_provider: '',
            llm_model: '',
            instructions: '',
            language_specific_instructions: {},
            role: 'specialist',
            is_default: agents.length === 0,
            date_time_context_enabled: false,
            deleted_tool_ids: [],
            common_tool_ids: [],
            agentSettings: {},
            tools: [],
            isNew: true,
        };
        setAgents(function (prev) { return __spreadArrays(prev, [localNewAgent]); });
        setSelectedSelection(tempId);
        setCurrentAgentDraft(VoiceAgentLayoutUtils_1.toAgentDraft(localNewAgent));
        setIsLocalEdited(true);
        setIsAddAgentModalActive(false);
        setNewAgentName('');
        setNewAgentNameError('');
    };
    var onSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var trimmedCommonDraft, toolValidationError_1, uniqueToolNameError_1, commonDraftWithLambdaNames, payload, saveResponse, refreshedDomainData, error_1, trimmedDraft, toolValidationError, uniqueToolNameError, agentDraftWithLambdaNames, requestPromise, _a, success, response, createdAgentId, error_2;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!(selectedSelection === VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION)) return [3 /*break*/, 9];
                    trimmedCommonDraft = VoiceAgentLayoutUtils_1.trimCommonConfigurationDraft(currentCommonDraft);
                    setCurrentCommonDraft(trimmedCommonDraft);
                    toolValidationError_1 = VoiceAgentLayoutUtils_1.validateVoiceAgentTools(trimmedCommonDraft === null || trimmedCommonDraft === void 0 ? void 0 : trimmedCommonDraft.tools);
                    if (showToolValidationError(toolValidationError_1)) {
                        return [2 /*return*/];
                    }
                    uniqueToolNameError_1 = VoiceAgentLayoutUtils_1.validateUniqueVoiceAgentToolNames(trimmedCommonDraft === null || trimmedCommonDraft === void 0 ? void 0 : trimmedCommonDraft.tools, allAgentTools, {
                        currentScopeLabel: 'common tools',
                        referenceScopeLabel: 'agent tools',
                    });
                    if (showToolValidationError(uniqueToolNameError_1)) {
                        return [2 /*return*/];
                    }
                    if (!Number.isFinite(pipecatVoiceId)) {
                        if (onParentSave)
                            onParentSave();
                        return [2 /*return*/];
                    }
                    setIsSaving(true);
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 6, 7, 8]);
                    return [4 /*yield*/, ensureToolCallLambdaNames(trimmedCommonDraft)];
                case 2:
                    commonDraftWithLambdaNames = _e.sent();
                    setCurrentCommonDraft(commonDraftWithLambdaNames);
                    payload = VoiceAgentLayoutUtils_1.buildCommonConfigurationPayload(botSettings, commonDraftWithLambdaNames);
                    return [4 /*yield*/, api_1.createBot(payload)];
                case 3:
                    saveResponse = _e.sent();
                    if (!(saveResponse === null || saveResponse === void 0 ? void 0 : saveResponse.success)) {
                        BotActions_1.createAlert((saveResponse === null || saveResponse === void 0 ? void 0 : saveResponse.error) || 'Error occurred while saving common data.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, DomainActions_1.getDomainData(activeDomainId)];
                case 4:
                    refreshedDomainData = _e.sent();
                    if (refreshedDomainData) {
                        dispatcher_1.dispatch(MogamboConstants_1.ActionTypes.SET_CURRENT_BOT_SETTINGS, {
                            settings: refreshedDomainData,
                        });
                        reduxDispatch(actions_1.setDomainData(refreshedDomainData));
                    }
                    return [4 /*yield*/, fetchMultiAgents(VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION)];
                case 5:
                    _e.sent();
                    setIsCommonEdited(false);
                    BotActions_1.createAlert('Successfully saved the common configuration.', null, MogamboConstants_1.AlertTypes.POSITIVE);
                    setIsCommonEdited(false);
                    return [3 /*break*/, 8];
                case 6:
                    error_1 = _e.sent();
                    BotActions_1.createAlert((error_1 === null || error_1 === void 0 ? void 0 : error_1.message) ||
                        'Error occurred while saving common configuration.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                    api_1.captureException(error_1);
                    return [3 /*break*/, 8];
                case 7:
                    setIsSaving(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
                case 9:
                    trimmedDraft = VoiceAgentLayoutUtils_1.trimAgentDraft(currentAgentDraft);
                    setCurrentAgentDraft(trimmedDraft);
                    if (!Number.isFinite(pipecatVoiceId)) {
                        if (onParentSave)
                            onParentSave();
                        return [2 /*return*/];
                    }
                    if (!(trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.id)) {
                        BotActions_1.createAlert('Please select an agent first.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                        return [2 /*return*/];
                    }
                    if (!(trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.modelProvider) || !(trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.model)) {
                        BotActions_1.createAlert('Please select both model provider and model before saving.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                        return [2 /*return*/];
                    }
                    toolValidationError = VoiceAgentLayoutUtils_1.validateVoiceAgentTools(trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.tools);
                    if (showToolValidationError(toolValidationError)) {
                        return [2 /*return*/];
                    }
                    uniqueToolNameError = VoiceAgentLayoutUtils_1.validateUniqueVoiceAgentToolNames(trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.tools, commonTools, {
                        currentScopeLabel: 'this agent',
                        referenceScopeLabel: 'common tools',
                    });
                    if (showToolValidationError(uniqueToolNameError)) {
                        return [2 /*return*/];
                    }
                    if ((trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.role) === 'faq' && (trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.isDefault)) {
                        BotActions_1.createAlert('FAQ agent cannot be marked as Default. Please select another agent as Default.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                        return [2 /*return*/];
                    }
                    if ((trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.isDefault) && defaultAgentOtherThanCurrent) {
                        BotActions_1.createAlert(VoiceAgentLayoutUtils_1.getAgentName(defaultAgentOtherThanCurrent, 0) + " is already marked as Default. Unset it first.", null, MogamboConstants_1.AlertTypes.NEGATIVE);
                        return [2 /*return*/];
                    }
                    if ((trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.role) === 'orchestrator' &&
                        orchestratorAgentOtherThanCurrent) {
                        BotActions_1.createAlert(VoiceAgentLayoutUtils_1.getAgentName(orchestratorAgentOtherThanCurrent, 0) + " is already set as Orchestrator. Unset it first.", null, MogamboConstants_1.AlertTypes.NEGATIVE);
                        return [2 /*return*/];
                    }
                    setIsSaving(true);
                    _e.label = 10;
                case 10:
                    _e.trys.push([10, 13, 14, 15]);
                    return [4 /*yield*/, ensureToolCallLambdaNames(trimmedDraft)];
                case 11:
                    agentDraftWithLambdaNames = _e.sent();
                    setCurrentAgentDraft(agentDraftWithLambdaNames);
                    requestPromise = (agentDraftWithLambdaNames === null || agentDraftWithLambdaNames === void 0 ? void 0 : agentDraftWithLambdaNames.isNew) ? api_2.createMultiAgentBot(pipecatVoiceId, VoiceAgentLayoutUtils_1.buildAgentPayload(__assign(__assign({}, agentDraftWithLambdaNames), { id: undefined })))
                        : api_2.updateMultiAgent(pipecatVoiceId, agentDraftWithLambdaNames.id, VoiceAgentLayoutUtils_1.buildAgentPayload(agentDraftWithLambdaNames));
                    return [4 /*yield*/, requestPromise];
                case 12:
                    _a = _e.sent(), success = _a.success, response = _a.response;
                    if (!success || (response === null || response === void 0 ? void 0 : response.success) === false) {
                        BotActions_1.createAlert((response === null || response === void 0 ? void 0 : response.error) || 'Error occurred while saving agent.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                        return [2 /*return*/];
                    }
                    BotActions_1.createAlert('Successfully saved the agent data.', null, MogamboConstants_1.AlertTypes.POSITIVE);
                    setIsLocalEdited(false);
                    createdAgentId = (_d = (_b = VoiceAgentLayoutUtils_1.getAgentId(VoiceAgentLayoutUtils_1.getResponseBody(response))) !== null && _b !== void 0 ? _b : VoiceAgentLayoutUtils_1.getAgentId((_c = VoiceAgentLayoutUtils_1.getResponseBody(response)) === null || _c === void 0 ? void 0 : _c.agent)) !== null && _d !== void 0 ? _d : agentDraftWithLambdaNames.id;
                    fetchMultiAgents(createdAgentId);
                    return [3 /*break*/, 15];
                case 13:
                    error_2 = _e.sent();
                    BotActions_1.createAlert((error_2 === null || error_2 === void 0 ? void 0 : error_2.message) || 'Error occurred while saving agent.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                    api_1.captureException(error_2);
                    return [3 /*break*/, 15];
                case 14:
                    setIsSaving(false);
                    return [7 /*endfinally*/];
                case 15: return [2 /*return*/];
            }
        });
    }); };
    var onDelete = function () {
        var deletingAgentName = (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.name) || '';
        var deletingAgentId = currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id;
        var affectedAgents = getAffectedRoutingAgents(deletingAgentName, deletingAgentId);
        var totalAffectedTools = affectedAgents.reduce(function (acc, agent) { var _a; return acc + (((_a = agent === null || agent === void 0 ? void 0 : agent.removedTools) === null || _a === void 0 ? void 0 : _a.length) || 0); }, 0);
        var affectedAgentsText = affectedAgents
            .map(function (agent) { return (agent === null || agent === void 0 ? void 0 : agent.name) + " (" + (agent === null || agent === void 0 ? void 0 : agent.removedTools.length) + ")"; })
            .join(', ');
        var deleteMessage = affectedAgents.length ? (react_1["default"].createElement(box_1["default"], null,
            react_1["default"].createElement(text_1["default"], { variant: "body.md", style: { whiteSpace: 'pre-line', fontSize: '15px' } }, "This agent is used as routing target in " + totalAffectedTools + " tool(s) in: " + affectedAgentsText + ".\nThose routing tools will also be deleted."))) : ('This action cannot be undone.');
        BotActions_1.showConfirmationDialog({
            okTitle: 'Delete',
            cancelTitle: 'Cancel',
            title: "Are you sure you want to delete '" + ((currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.name) || 'this agent') + "'?",
            message: deleteMessage,
            okActionType: 'danger',
            onCancel: function () { },
            onOk: function () {
                var _a;
                if (affectedAgents.length) {
                    setAgents(function (prevAgents) {
                        return prevAgents.map(function (agent) {
                            var agentId = VoiceAgentLayoutUtils_1.getAgentId(agent);
                            var affected = affectedAgents.find(function (a) { return (a === null || a === void 0 ? void 0 : a.id) === agentId; });
                            if (!affected || !affected.isNew)
                                return agent;
                            return __assign(__assign({}, agent), { tools: affected.updatedDraft.tools, deleted_tool_ids: affected.updatedDraft.deletedToolIds });
                        });
                    });
                }
                if (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.isNew) {
                    var updatedAgents = agents.filter(function (agent) { return VoiceAgentLayoutUtils_1.getAgentId(agent) !== (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id); });
                    setAgents(updatedAgents);
                    var fallbackId = (_a = VoiceAgentLayoutUtils_1.getAgentId(updatedAgents === null || updatedAgents === void 0 ? void 0 : updatedAgents[0])) !== null && _a !== void 0 ? _a : null;
                    setSelectedSelection(fallbackId);
                    if (!updatedAgents.length) {
                        setCurrentAgentDraft(null);
                    }
                    setIsLocalEdited(false);
                    return;
                }
                if (!Number.isFinite(pipecatVoiceId) || !(currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id)) {
                    if (onDeleteClick)
                        onDeleteClick(currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id);
                    return;
                }
                setIsDeleteLoading(true);
                var updateAffectedAgentsPromise = Promise.all(affectedAgents
                    .filter(function (agent) { return !(agent === null || agent === void 0 ? void 0 : agent.isNew) && (agent === null || agent === void 0 ? void 0 : agent.id); })
                    .map(function (agent) {
                    return api_2.updateMultiAgent(pipecatVoiceId, agent === null || agent === void 0 ? void 0 : agent.id, VoiceAgentLayoutUtils_1.buildAgentPayload(agent === null || agent === void 0 ? void 0 : agent.updatedDraft));
                }));
                updateAffectedAgentsPromise
                    .then(function (responses) {
                    var _a;
                    var failedUpdate = responses.find(function (_a) {
                        var success = _a.success, response = _a.response;
                        return !success || (response === null || response === void 0 ? void 0 : response.success) === false;
                    });
                    if (failedUpdate) {
                        throw new Error(((_a = failedUpdate === null || failedUpdate === void 0 ? void 0 : failedUpdate.response) === null || _a === void 0 ? void 0 : _a.error) ||
                            'Error occurred while updating routing tools.');
                    }
                    return api_2.deleteMultiAgent(pipecatVoiceId, currentAgentDraft.id, {});
                })
                    .then(function (_a) {
                    var success = _a.success, response = _a.response;
                    if (!success || (response === null || response === void 0 ? void 0 : response.success) === false) {
                        BotActions_1.createAlert((response === null || response === void 0 ? void 0 : response.error) || 'Error occurred while deleting agent.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                        return;
                    }
                    BotActions_1.createAlert('Agent deleted successfully.', null, MogamboConstants_1.AlertTypes.POSITIVE);
                    fetchMultiAgents();
                })["catch"](function (error) {
                    BotActions_1.createAlert((error === null || error === void 0 ? void 0 : error.message) || 'Error occurred while deleting agent.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                    api_1.captureException(error);
                })["finally"](function () {
                    setIsDeleteLoading(false);
                });
            },
        });
    };
    var onCommonSelect = function () {
        if (selectedSelection === VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION)
            return;
        if (isLocalEdited || isCommonEdited || isEdited) {
            BotActions_1.showConfirmationDialog({
                okTitle: 'Switch',
                cancelTitle: 'Keep Editing',
                title: 'Switch configuration?',
                message: 'Your unsaved changes will be lost once you switch views.',
                okActionType: 'danger',
                onCancel: function () { },
                onOk: function () {
                    var _a;
                    if (selectedSelection !== VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION && (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.isNew) && (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id)) {
                        setAgents(function (prevAgents) {
                            return prevAgents.filter(function (agent) { return VoiceAgentLayoutUtils_1.getAgentId(agent) !== (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id); });
                        });
                    }
                    setCurrentCommonDraft(currentCommonConfiguration);
                    setCommonTools((_a = currentCommonConfiguration.tools) !== null && _a !== void 0 ? _a : []);
                    setIsCommonEdited(false);
                    setIsLocalEdited(false);
                    setSelectedSelection(VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION);
                },
            });
            return;
        }
        setSelectedSelection(VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION);
    };
    var onAgentSelect = function (agentId) {
        if (agentId === selectedSelection)
            return;
        if (isLocalEdited || isCommonEdited || isEdited) {
            BotActions_1.showConfirmationDialog({
                okTitle: 'Switch',
                cancelTitle: 'Keep Editing',
                title: 'Switch agent?',
                message: 'Your unsaved changes will be lost once you switch to another agent.',
                okActionType: 'danger',
                onCancel: function () { },
                onOk: function () {
                    var _a;
                    if (selectedSelection !== VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION && (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.isNew) && (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id)) {
                        setAgents(function (prevAgents) {
                            return prevAgents.filter(function (agent) { return VoiceAgentLayoutUtils_1.getAgentId(agent) !== (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id); });
                        });
                    }
                    setCurrentCommonDraft(currentCommonConfiguration);
                    setCommonTools((_a = currentCommonConfiguration.tools) !== null && _a !== void 0 ? _a : []);
                    setIsCommonEdited(false);
                    setIsLocalEdited(false);
                    setSelectedSelection(agentId);
                },
            });
            return;
        }
        setSelectedSelection(agentId);
    };
    var selectedProvider = providerOptions.find(function (provider) { return provider.id === (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.modelProvider); }) || {};
    var selectedModel = modelOptions.find(function (model) { return model.id === (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.model); }) || {};
    var selectedRole = VoiceAgentLayoutUtils_1.AGENT_ROLE_OPTIONS.find(function (role) { return role.id === (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.role); }) ||
        VoiceAgentLayoutUtils_1.AGENT_ROLE_OPTIONS[0];
    var currentAgentIndex = agents.findIndex(function (agent) { return VoiceAgentLayoutUtils_1.getAgentId(agent) === (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id); });
    var isCommonConfigurationSelected = selectedSelection === VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION;
    var hasUnsavedChanges = Boolean(isCommonEdited || isLocalEdited || isEdited);
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement(box_1["default"], { flexDirection: "row", padding: "0", style: { gap: '24px' } },
            react_1["default"].createElement(VoiceAgentSidebar_1["default"], { isLoading: isLoading, agentOptions: agentOptions, selectedSelection: selectedSelection, onCommonSelect: onCommonSelect, onAgentSelect: onAgentSelect, onAddAgent: onAddAgent }),
            selectedSelection !== null || isLoading || isModelsLoading ? (react_1["default"].createElement(box_1["default"], { padding: "0", flexDirection: "column", style: { flex: 1, minWidth: 0 } },
                react_1["default"].createElement(box_1["default"], { style: { alignSelf: 'flex-end', gap: '4px' } },
                    !isCommonConfigurationSelected && (react_1["default"].createElement(StyledComponets_1.StyledButton, { themed: true, variant: isSaving || isDeleteLoading || !currentAgentDraft
                            ? 'disabled'
                            : 'warning', onClick: onDelete, disabled: isSaving || isDeleteLoading || !currentAgentDraft }, "Delete")),
                    react_1["default"].createElement(StyledComponets_1.StyledButton, { themed: true, type: "primary", onClick: onSave, disabled: (isCommonConfigurationSelected
                            ? !currentCommonDraft
                            : !currentAgentDraft) ||
                            isSaving ||
                            isDeleteLoading ||
                            store_1["default"].isProductionEnv() ||
                            !hasUnsavedChanges }, isSaving ? 'Saving...' : 'Save')),
                react_1["default"].createElement(box_1["default"], { padding: "0", flexDirection: "column", style: { gap: '8px', marginTop: '8px' } },
                    (isLoading || isModelsLoading) && (react_1["default"].createElement(box_1["default"], { height: "100%", alignItems: "center", justifyContent: "center" },
                        react_1["default"].createElement(loader_1["default"], { themed: true }))),
                    isDeleteLoading && (react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "grey.dark" }, "Deleting agent...")),
                    !isLoading && !isModelsLoading && (react_1["default"].createElement(react_1["default"].Fragment, null,
                        react_1["default"].createElement(box_1["default"], { flexDirection: "column", style: { gap: '6px' } },
                            react_1["default"].createElement(text_1["default"], { variant: "h1.semi-bold", color: "black.haptik" }, isCommonConfigurationSelected
                                ? 'Common Configuration'
                                : currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.name)),
                        isCommonConfigurationSelected ? (react_1["default"].createElement(react_1["default"].Fragment, null,
                            react_1["default"].createElement(box_1["default"], { flexDirection: "column" },
                                react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "black.haptik" }, "Common Prompt"),
                                react_1["default"].createElement(StyledComponets_1.StyledTextInput, { themed: true, multiline: true, autoExpand: true, maxHeight: 400, placeholder: "Enter common prompt", value: (_j = currentCommonDraft === null || currentCommonDraft === void 0 ? void 0 : currentCommonDraft.systemPrompt) !== null && _j !== void 0 ? _j : '', onChange: function (value) {
                                        return updateCommonDraft('systemPrompt', value);
                                    } })),
                            react_1["default"].createElement(box_1["default"], { flexDirection: "column" },
                                react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "black.haptik" }, "Common Guardrails"),
                                react_1["default"].createElement(StyledComponets_1.StyledTextInput, { themed: true, multiline: true, autoExpand: true, maxHeight: 400, placeholder: "Enter common guardrails", value: (_k = currentCommonDraft === null || currentCommonDraft === void 0 ? void 0 : currentCommonDraft.guardrails) !== null && _k !== void 0 ? _k : '', onChange: function (value) {
                                        return updateCommonDraft('guardrails', value);
                                    } })),
                            react_1["default"].createElement(box_1["default"], { flexDirection: "column" },
                                react_1["default"].createElement(text_1["default"], { variant: "h2.semi-bold", color: "black.haptik" }, "Common Tools"),
                                ((_l = currentCommonDraft === null || currentCommonDraft === void 0 ? void 0 : currentCommonDraft.tools) !== null && _l !== void 0 ? _l : []).map(function (tool, index) {
                                    return (react_1["default"].createElement(VoiceAgentToolItem_1["default"], { key: (tool === null || tool === void 0 ? void 0 : tool.id) || "common-tool-" + index, toolData: tool, number: index + 1, nextAgentOptions: agentOptions, onToolChange: function (field, value) {
                                            return updateToolDraft(index, field, value);
                                        }, onDeleteTool: function () { return onDeleteTool(index); } }));
                                }),
                                !((_m = currentCommonDraft === null || currentCommonDraft === void 0 ? void 0 : currentCommonDraft.tools) === null || _m === void 0 ? void 0 : _m.length) && (react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "grey.dark" }, "No common tools added yet.")),
                                react_1["default"].createElement(box_1["default"], { padding: "0", justifyContent: "flex-end" },
                                    react_1["default"].createElement(StyledComponets_1.StyledButton, { themed: true, variant: "secondary", onClick: onAddTool }, "Add tool"))))) : (react_1["default"].createElement(box_1["default"], { flexDirection: "column" },
                            react_1["default"].createElement(box_1["default"], { style: { gap: '16px' } },
                                react_1["default"].createElement(dropdown_1["default"], { placeholder: "Select a model provider", themed: true, options: providerOptions, value: selectedProvider, optionKey: "name", onChange: function (val) {
                                        var _a;
                                        updateAgentDraft('modelProvider', (_a = val === null || val === void 0 ? void 0 : val.id) !== null && _a !== void 0 ? _a : '');
                                        updateAgentDraft('model', '');
                                    }, label: react_1["default"].createElement(Label_1["default"], { info: "", text: "Model Provider", isBold: true }) }),
                                react_1["default"].createElement(dropdown_1["default"], { placeholder: "Select a model", themed: true, options: modelOptions, value: selectedModel, optionKey: "name", onChange: function (val) { var _a; return updateAgentDraft('model', (_a = val === null || val === void 0 ? void 0 : val.id) !== null && _a !== void 0 ? _a : ''); }, label: react_1["default"].createElement(Label_1["default"], { info: "", text: "Model", isBold: true }) })),
                            react_1["default"].createElement(box_1["default"], { flexDirection: "column" },
                                react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "black.haptik" }, "Agent Role"),
                                react_1["default"].createElement(dropdown_1["default"], { placeholder: "Select agent role", themed: true, options: VoiceAgentLayoutUtils_1.AGENT_ROLE_OPTIONS, value: selectedRole, optionKey: "name", onChange: function (val) {
                                        if ((val === null || val === void 0 ? void 0 : val.id) === 'orchestrator' &&
                                            orchestratorAgentOtherThanCurrent) {
                                            BotActions_1.createAlert(VoiceAgentLayoutUtils_1.getAgentName(orchestratorAgentOtherThanCurrent, 0) + " is already set as Orchestrator. Unset it first.", null, MogamboConstants_1.AlertTypes.NEGATIVE);
                                            return;
                                        }
                                        if ((val === null || val === void 0 ? void 0 : val.id) === 'faq' &&
                                            (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.role) !== 'faq') {
                                            BotActions_1.showConfirmationDialog({
                                                okTitle: 'Switch',
                                                cancelTitle: 'Keep Editing',
                                                title: 'Switch to FAQ agent?',
                                                message: 'All tools will get removed if you switch to FAQ agent.',
                                                okActionType: 'danger',
                                                onCancel: function () { },
                                                onOk: function () {
                                                    updateAgentDraft('role', val === null || val === void 0 ? void 0 : val.id);
                                                },
                                            });
                                            return;
                                        }
                                        updateAgentDraft('role', val === null || val === void 0 ? void 0 : val.id);
                                    }, style: { width: '200px' } })),
                            react_1["default"].createElement(box_1["default"], { alignItems: "center", style: { gap: '8px' } },
                                react_1["default"].createElement(toggle_1["default"], { themed: true, value: Boolean(currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.isDefault), onChange: function (checked) {
                                        if (checked && (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.role) === 'faq') {
                                            BotActions_1.createAlert('FAQ agent cannot be marked as Default. Please select another agent as Default.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                                            return;
                                        }
                                        if (checked && defaultAgentOtherThanCurrent) {
                                            BotActions_1.createAlert(VoiceAgentLayoutUtils_1.getAgentName(defaultAgentOtherThanCurrent, 0) + " is already marked as Default. Unset it first.", null, MogamboConstants_1.AlertTypes.NEGATIVE);
                                            return;
                                        }
                                        updateAgentDraft('isDefault', checked);
                                    }, disabled: store_1["default"].isProductionEnv(), style: { width: 'max-content' } }),
                                noDefaultAgent &&
                                    !(currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.isDefault) &&
                                    currentAgentIndex === 0 && (react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "green.haptik" }, "(Considered Default)")),
                                react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Is this Agent the \"Default\" Agent?")),
                            react_1["default"].createElement(box_1["default"], { alignItems: "center", style: { gap: '8px' } },
                                react_1["default"].createElement(toggle_1["default"], { themed: true, value: Boolean(currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.enableDateTimeContext), onChange: function (checked) {
                                        return updateAgentDraft('enableDateTimeContext', checked);
                                    }, disabled: store_1["default"].isProductionEnv(), style: { width: 'max-content' } }),
                                react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Enable Date/Time context for this Agent")),
                            Array.isArray(selectedAgentSettingsTemplate) &&
                                selectedAgentSettingsTemplate.length > 0 &&
                                !isFaq && (react_1["default"].createElement(accordion_1["default"], null,
                                react_1["default"].createElement(StyledComponets_1.DynamicSettingsAccordionItem, { active: dynamicSettingsAccordionActive, onChange: function () {
                                        return setDynamicSettingsAccordionActive(function (active) { return !active; });
                                    }, renderHeader: function (_a) {
                                        var ExpandIcon = _a.ExpandIcon;
                                        return (react_1["default"].createElement(box_1["default"], { color: "black.haptik", padding: "8px 16px", justifyContent: "space-between", marginBottom: dynamicSettingsAccordionActive ? '8px' : '0', alignItems: "center" },
                                            react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Settings"),
                                            react_1["default"].createElement(ExpandIcon, null)));
                                    } },
                                    react_1["default"].createElement(VoiceAgentDynamicSettings_1["default"], { dynamicSettings: selectedAgentSettingsTemplate, agentSettings: currentAgentDraft, onChange: updateAgentSettingsDraft })))),
                            react_1["default"].createElement(box_1["default"], { flexDirection: "column", mt: "8px" },
                                react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "black.haptik" }, "Common Prompt"),
                                react_1["default"].createElement(StyledComponets_1.StyledTextInputDisabled, { themed: true, multiline: true, autoExpand: true, maxHeight: 400, placeholder: "No common prompt added yet.", value: (_p = (_o = botSettings === null || botSettings === void 0 ? void 0 : botSettings['bot_settings']) === null || _o === void 0 ? void 0 : _o['common_system_prompt']) !== null && _p !== void 0 ? _p : '', disabled: true })),
                            react_1["default"].createElement(box_1["default"], { flexDirection: "column" },
                                react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "black.haptik" }, "Agent Instructions"),
                                react_1["default"].createElement(StyledComponets_1.StyledTextInput, { themed: true, multiline: true, autoExpand: true, maxHeight: 400, placeholder: "Enter Instructions for the agent", value: (_q = currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.instructions) !== null && _q !== void 0 ? _q : '', onChange: function (value) {
                                        return updateAgentDraft('instructions', value);
                                    } })),
                            react_1["default"].createElement(box_1["default"], { flexDirection: "column" },
                                react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "black.haptik" }, "Common Guardrails"),
                                react_1["default"].createElement(StyledComponets_1.StyledTextInputDisabled, { themed: true, multiline: true, autoExpand: true, maxHeight: 400, placeholder: "No common guardrails added yet.", value: (_s = (_r = botSettings === null || botSettings === void 0 ? void 0 : botSettings['bot_settings']) === null || _r === void 0 ? void 0 : _r['common_guardrails']) !== null && _s !== void 0 ? _s : '', disabled: true })),
                            react_1["default"].createElement(box_1["default"], { flexDirection: "column" },
                                react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "black.haptik" }, "Language Specific Instructions"),
                                react_1["default"].createElement(box_1["default"], { padding: "2px 0px 8px", style: { gap: '12px' }, alignItems: "flex-start" },
                                    react_1["default"].createElement(box_1["default"], { padding: "0", flexDirection: "column", style: { minWidth: '200px' } },
                                        react_1["default"].createElement(dropdown_1["default"], { themed: true, placeholder: "Select language", options: languagesList, value: selectedLanguage, optionKey: "name", onChange: function (val) { return setSelectedLanguage(val); }, style: { width: '200px' } }),
                                        react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "grey.dark", style: { marginTop: '8px' } },
                                            configuredLanguageCount,
                                            " languages configured")),
                                    react_1["default"].createElement(StyledComponets_1.StyledTextInput, { themed: true, multiline: true, autoExpand: true, maxHeight: 400, placeholder: "Enter Instructions for the agent", value: (_u = (_t = currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.languageSpecificInstructions) === null || _t === void 0 ? void 0 : _t[selectedLanguageCode]) !== null && _u !== void 0 ? _u : '', onChange: function (value) {
                                            var _a;
                                            return updateAgentDraft('languageSpecificInstructions', __assign(__assign({}, currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.languageSpecificInstructions), (_a = {}, _a[selectedLanguageCode] = value, _a)));
                                        }, disabled: !(selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.code), style: { marginTop: '6px', minHeight: '200px' } }))),
                            !isFaq && (react_1["default"].createElement(box_1["default"], { flexDirection: "column" },
                                react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "black.haptik" }, "Common Tools"),
                                sharedCommonTools.length ? (react_1["default"].createElement(box_1["default"], { padding: "0", flexDirection: "column", style: { gap: '8px' } }, sharedCommonTools.map(function (tool, index) {
                                    var _a, _b;
                                    var toolId = (_b = (_a = tool === null || tool === void 0 ? void 0 : tool.id) !== null && _a !== void 0 ? _a : tool === null || tool === void 0 ? void 0 : tool['tool_id']) !== null && _b !== void 0 ? _b : tool === null || tool === void 0 ? void 0 : tool['common_tool_id'];
                                    var enabled = isCommonToolEnabled(toolId);
                                    var isSelfHandoff = isCommonToolSelfHandoff(tool);
                                    return (react_1["default"].createElement(VoiceAgentToolItem_1["default"], { key: toolId !== null && toolId !== void 0 ? toolId : "common-tool-" + index, toolData: tool, number: index + 1, nextAgentOptions: agentOptions, onToolChange: function () { }, readOnly: true, headerActions: react_1["default"].createElement(box_1["default"], { padding: "0", alignItems: "flex-end", flexDirection: "column", style: { gap: '4px' } },
                                            react_1["default"].createElement(toggle_1["default"], { themed: true, value: enabled, disabled: isSelfHandoff, onChange: function (checked) {
                                                    return updateCommonToolAccess(toolId, checked);
                                                }, style: { width: 'max-content' } }),
                                            isSelfHandoff && (react_1["default"].createElement(text_1["default"], { variant: "body.sm", color: "red.haptik", style: { textAlign: 'right' } }, "Disabled to avoid routing back to this same agent."))) }));
                                }))) : (react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "grey.dark" }, "No common tools added yet.")))),
                            !isFaq && (react_1["default"].createElement(box_1["default"], { flexDirection: "column" },
                                react_1["default"].createElement(text_1["default"], { variant: "h2.semi-bold", color: "black.haptik" }, "Tools"),
                                ((_v = currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.tools) !== null && _v !== void 0 ? _v : []).map(function (tool, index) {
                                    return (react_1["default"].createElement(VoiceAgentToolItem_1["default"], { key: (tool === null || tool === void 0 ? void 0 : tool.id) || "tool-" + index, toolData: tool, number: index + 1, nextAgentOptions: agentOptions.filter(function (agent) { return agent.id !== selectedAgentId; }), onToolChange: function (field, value) {
                                            return updateToolDraft(index, field, value);
                                        }, onDeleteTool: function () { return onDeleteTool(index); } }));
                                }),
                                !((_w = currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.tools) === null || _w === void 0 ? void 0 : _w.length) && (react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "grey.dark" }, "No tools added for this agent.")),
                                react_1["default"].createElement(box_1["default"], { padding: "0", justifyContent: "flex-end" },
                                    react_1["default"].createElement(StyledComponets_1.StyledButton, { themed: true, variant: "secondary", onClick: onAddTool }, "Add tool"))))))))))) : (react_1["default"].createElement(box_1["default"], { padding: "16px", height: "calc(100vh - 140px)", alignItems: "center", justifyContent: "center", flexDirection: "column", backgroundColor: "#fff", style: { borderRadius: '8px' } },
                react_1["default"].createElement("img", { src: "https://tools-cdn.s3.ap-south-1.amazonaws.com/platform/assets/no_agents_multi_agent.png", alt: "No agents", style: { width: '40%', marginBottom: '16px' } }),
                react_1["default"].createElement(text_1["default"], { variant: "h1.semi-bold" }, "No agents in this project yet"),
                react_1["default"].createElement(text_1["default"], { variant: "body.lg", style: { marginTop: '8px', width: '50%', textAlign: 'center' } }, "Create your first AI agent using \u201CAdd Agent\u201D in the sidebar. You can add multiple agents to handle different tasks.")))),
        react_1["default"].createElement(VoiceAgentAddAgentModal_1["default"], { isActive: isAddAgentModalActive, newAgentName: newAgentName, newAgentNameError: newAgentNameError, setNewAgentName: setNewAgentName, setNewAgentNameError: setNewAgentNameError, onConfirm: onConfirmAddAgent, onClose: function () {
                setIsAddAgentModalActive(false);
                setNewAgentName('');
                setNewAgentNameError('');
            } })));
};
exports["default"] = VoiceAgentLayout;
